import React, {useState, useEffect} from 'react';
import { getDocs , collection , db , setDoc , doc , deleteDoc } from '../../firebase';
import SideBar from '../components/Sidebar';
import sidebar_menu from '../components/sidebar-menu';


function SubPackages (  ) {
  
    const [ subpackagesArray , setSubPackagesArray ] = useState([]);

    const [addShow , setAddShow] = useState(false);
    const [showTable , setTableShow] = useState(true);

    const [updateShow , setUpdateShow] = useState(false);
    const [ deleteShow , setDeleteShow] = useState(false);

    const [success , setSuccess ] = useState(false);

    const [error , setError ] = useState('');

    const [ serviceName , setServiceName ] = useState('');
    const [servicePrice , setServicePrice ] = useState('');
    const [serviceDesc , setServiceDesc ] = useState('');
    const [serviceRating , setServiceRating ] = useState('');
    const [serviceImage , setServiceImage ] = useState('');
    const [serviceProvider , setServiceProvidere ] = useState('');
    const [serviceType , setServiceType ] = useState('');


    const [ serviceId , setServiceId ] = useState('');


    const makeid = (length) =>  {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * 
     charactersLength));
       }
       return result;
    }


    
  useEffect(  () => {

    const getSubPackagesData = async () => { 
      const querySnapshot = await getDocs(collection(db, "sub_packages"));
      const subPackagesData = querySnapshot.docs
      .map((doc) => ({ ...doc.data(), id: doc.id }));
        
      setSubPackagesArray(subPackagesData);
     
    }
    getSubPackagesData();
  } , []);

 


    const addNewSubPackage =  async (e) => {

        e.preventDefault();
     

    if (serviceName === ''  ) {
          setError(' يرجى ادخال اسم الخدمة ');
    }
    
    if (serviceImage === ''  ) {
    setError(' يرجى ادخال صورة للخدمة ');
    }
    
    
    if (servicePrice === ''  ) {
        setError(' يرجى ادخال سعر للخدمة ');
    }   
    
    if (serviceRating === ''  ) {
        setError(' يرجى ادخال تقييم للخدمة ');
    }
    
    if (serviceDesc === ''  ) {
        setError(' يرجى ادخال وصف للخدمة ');
    }
    
    if (serviceProvider === ''  ) {
        setError(' يرجى ادخال مقدم للخدمة ');
    }
    
    if (serviceType === ''  ) {
        setError(' يرجى ادخال نوع للخدمة ');
    }
    
        if (serviceName !== '' && serviceImage !== '' && servicePrice && serviceRating && serviceDesc && serviceProvider && serviceType ) {

            const sub_packages = await setDoc(doc(db, "sub_packages", makeid(20)), {

              service_name: serviceName,
              service_desc: serviceDesc,
              image: serviceImage,
              price: servicePrice,
              rating: serviceRating,
              service_type: serviceType,
              service_provider: serviceProvider
              
             
              });

            
                setSuccess(true);
                setError('');

                setTimeout(() => {
                    setSuccess('');
                    window.location.reload();
                } , 1350);

             

        }
    }

    const updateShownMethod = ( service_name , service_desc , image , price , rating , type , id ) => {

        setServiceName(service_name);
        setServiceDesc(service_desc);
        setServiceImage(image);
        setServicePrice(price);
        setServiceRating(rating);
        setServiceType(type);
     
        setServiceId(id);
    
    
    
        determineShow('update');
      }

      const deleteShowMethod = (  service_name , service_desc , image , price , rating , type , id  ) => {

        setServiceName(service_name);
        setServiceDesc(service_desc);
        setServiceImage(image);
        setServicePrice(price);
        setServiceRating(rating);
        setServiceType(type);
     
        setServiceId(id);
    
            
        determineShow('delete');
      }

    const determineShow = ( param ) => {

        switch(param) {
            
            case 'show':
                setServiceName('');
                setServiceDesc('');
                setServiceImage('');
                setServicePrice('');
                setServiceRating('');
                setServiceType('');
                setTableShow(true);
                setAddShow(false);
                setUpdateShow(false);
                setDeleteShow(false);
                break;

            case 'update':
                setTableShow(false);
                setAddShow(false);
                setUpdateShow(true);
                setDeleteShow(false);
                break;

            case 'delete':
                setTableShow(false);
                setAddShow(false);
                setUpdateShow(false);
                setDeleteShow(true);
                break;

            case 'add':
                setTableShow(false);
                setAddShow(true);
                setUpdateShow(false);
                setDeleteShow(false);
                break;
        }
    }

    const updateRecord = async (e) => {
        e.preventDefault();
        const docRef = doc(db, "sub_packages", serviceId);
    
    const data = {

        service_name: serviceName,
        service_desc: serviceDesc,
        image: serviceImage,
        price: servicePrice,
        rating: serviceRating,
        service_type: serviceType
        
    };
    
    if (serviceName === ''  ) {
        setError(' يرجى ادخال اسم الخدمة ');
  }
  
  if (serviceImage === ''  ) {
  setError(' يرجى ادخال صورة للخدمة ');
  }
  
  
  if (servicePrice === ''  ) {
      setError(' يرجى ادخال سعر للخدمة ');
  }   
  
  if (serviceRating === ''  ) {
      setError(' يرجى ادخال تقييم للخدمة ');
  }
  
  if (serviceDesc === ''  ) {
      setError(' يرجى ادخال وصف للخدمة ');
  }
  
  if (serviceProvider === ''  ) {
      setError(' يرجى ادخال مقدم للخدمة ');
  }
  
  if (serviceType === ''  ) {
      setError(' يرجى ادخال نوع للخدمة ');
  }

    if (error === '') {
        setDoc(docRef, data)
    
        setSuccess(true);
        setTimeout(() => {
            setSuccess('');
            determineShow('show');
        } , 1350);
    }

  
    
    
      }

      const deleteRecord = async (e) => {
        e.preventDefault();
      
        await deleteDoc(doc(db, "sub_packages", serviceId));
        setSuccess(true);
        setTimeout(() => {
            setSuccess('');
            determineShow('show');
        } , 1350);
      }
  
      
   

    return(
        <div className="main_admin">

    <div className="sidebar_admin">
    <SideBar menu={sidebar_menu} />
    </div>

    <div className="content_admin">
    <div className='dashboard-content'>
            

            <div className='dashboard-content-container'>

            {addShow && (
                <>
                <div className='dashboard-content-header'>

                <h2 className='admin_headline' > اضافة البكجات  </h2>
                <div className='dashboard-content-search'>

                <button className="dashbord-header-btn_2" onClick={() => determineShow('show') } >رؤية جميع البكجات</button>
                    </div>           

                </div>

                {error && (
                            <>
                            <h1 className="my-1 error_headline"> {error} </h1>
                            </>
                        )}

                {success && (
                    <>
                        <div className="popup_success">
                            <img src="/images/icons/check.png" alt="" />
                        </div>
                    </>
                )}
                          
                <form onSubmit={addNewSubPackage} >

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> اسم الخدمة </label>
               
                <input value={serviceName} onChange={ (e) => setServiceName(e.target.value)  } type="text" id='name' className="input_form" placeholder='اسم الخدمة...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> وصف الخدمة </label>
               
                <input value={serviceDesc} onChange={ (e) => setServiceDesc(e.target.value)  } type="text" id='name' className="input_form" placeholder='وصف الخدمة...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> سعر الخدمة </label>
               
                <input value={servicePrice} onChange={ (e) => setServicePrice(e.target.value)  } type="text" id='name' className="input_form" placeholder='سعر الخدمة...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> صورة الخدمة </label>
               
                <input value={serviceImage} onChange={ (e) => setServiceImage(e.target.value)  } type="text" id='name' className="input_form" placeholder='صورة الخدمة...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> مقدم الخدمة </label>
               
                <input value={serviceProvider} onChange={ (e) => setServiceProvidere(e.target.value)  } type="text" id='name' className="input_form" placeholder='مقدم الخدمة...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> تقييم الخدمة </label>
               
            <select required name="stars" id="stars" value={serviceRating} className="input_form" onChange={(e) => {
        const selectedStar = e.target.value;
        setServiceRating(selectedStar);
      }} >
      <option value=""   hidden>اختر عدد النجوم</option>
      <option value="1">  1 </option>
      <option value="2">  2   </option>
      <option value="3">   3   </option>
      <option value="4">   4  </option>
      <option value="5">   5  </option>
     
      </select>

              
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> نوع الخدمة </label>
               
            <select required name="stars" id="stars" value={serviceType} className="input_form" onChange={(e) => {
        const selectedType = e.target.value;
        setServiceType(selectedType);
      }} >
      <option value=""   hidden> اختر نوع الخدمة </option>
      <option value="hotel">  فندق </option>
      <option value="photography">  تصوير   </option>
      <option value="tour_guide">  ارشاد سياحي   </option>
     
      </select>

            </div>



            <button  type='submit' className="dashbord-header-btn_2 w-80">اضافة الخدمة</button>


            </form>
                </>

            )}
            
            {updateShow && (
                <>
                <div className='dashboard-content-header'>

                <h2 className='admin_headline' >تعديل الخدمة </h2>
                <div className='dashboard-content-search'>

                <button className="dashbord-header-btn_2" onClick={() => determineShow('show') } >رؤية جميع العلامات</button>
                    </div>           

                </div>

                {error && (
                            <>
                            <h1 className="my-1 error_headline"> {error} </h1>
                            </>
                        )}

                {success && (
                    <>
                        <div className="popup_success">
                            <img src="/images/icons/check.png" alt="" />
                        </div>
                    </>
                )}
                          
                <form onSubmit={updateRecord} >

                <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> اسم الخدمة </label>
               
                <input value={serviceName} onChange={ (e) => setServiceName(e.target.value)  } type="text" id='name' className="input_form" placeholder='اسم الخدمة...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> وصف الخدمة </label>
               
                <input value={serviceDesc} onChange={ (e) => setServiceDesc(e.target.value)  } type="text" id='name' className="input_form" placeholder='وصف الخدمة...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> سعر الخدمة </label>
               
                <input value={servicePrice} onChange={ (e) => setServicePrice(e.target.value)  } type="text" id='name' className="input_form" placeholder='سعر الخدمة...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> صورة الخدمة </label>
               
                <input value={serviceImage} onChange={ (e) => setServiceImage(e.target.value)  } type="text" id='name' className="input_form" placeholder='صورة الخدمة...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> مقدم الخدمة </label>
               
                <input value={serviceProvider} onChange={ (e) => setServiceProvidere(e.target.value)  } type="text" id='name' className="input_form" placeholder='مقدم الخدمة...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> تقييم الخدمة </label>
               
            <select required name="stars" id="stars" value={serviceRating} className="input_form" onChange={(e) => {
        const selectedStar = e.target.value;
        setServiceRating(selectedStar);
      }} >
      <option value=""   hidden>اختر عدد النجوم</option>
      <option value="1">  1 </option>
      <option value="2">  2   </option>
      <option value="3">   3   </option>
      <option value="4">   4  </option>
      <option value="5">   5  </option>
     
      </select>

              
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> نوع الخدمة </label>
               
            <select required name="stars" id="stars" value={serviceType} className="input_form" onChange={(e) => {
        const selectedType = e.target.value;
        setServiceType(selectedType);
      }} >
      <option value=""   hidden> اختر نوع الخدمة </option>
      <option value="hotel">  فندق </option>
      <option value="photography">  تصوير   </option>
     
      </select>

            </div>


            <button className="dashbord-header-btn_2 w-80" type='submit' > تعديل ملعومات الخدمة </button>


            </form>
                </>

            )}
            
            {deleteShow && (
                <>
                <div className='dashboard-content-header'>

                <h2 className='admin_headline' > حذف الخدمة </h2>
                <div className='dashboard-content-search'>

                <button className="dashbord-header-btn_2" onClick={() => determineShow('show') } >رؤية جميع الخدمة</button>
                    </div>           

                </div>

                {error && (
                            <>
                            <h1 className="my-1 error_headline"> {error} </h1>
                            </>
                        )}

                {success && (
                    <>
                        <div className="popup_success">
                            <img src="/images/icons/check.png" alt="" />
                        </div>
                    </>
                )}
                          
                <form onSubmit={deleteRecord} >

              
          

            <button className="dashbord-header-btn_2 w-80 bg_red" type='submit'  >حذف الخدمة</button>


            </form>
                </>

            )}

            {showTable && (
                <>
                <div className='dashboard-content-header'>
                    <h2 className='admin_headline' >قائمة الاشعارات </h2>
                    <div className='dashboard-content-search'>

                <button className="dashbord-header-btn_2" onClick={() => determineShow('add') } >  اضافة خدمة جديدة</button>
                    </div>   
                   
                </div>

                {subpackagesArray && (
                    <table className='admin_table_dashboard' >
                    <thead>
                        
                        <th className='table_item' >اسم الخدمة</th>
                        <th className='table_item' >وصف الخدمة</th>
                        <th className='table_item' >سعر الخدمة</th>
                        <th className='table_item'> صورة الخدمة </th>
                        <th className='table_item'> نوع الخدمة </th>
                 
              
                        <th className='table_item'>التعديل \ الحذف</th>

                    </thead>

                    <tbody>

                        {subpackagesArray.map((item , i) => (
                            <tr key={i} >

                         
                            <td className='table_item_sm' > {item.service_name} </td>
                        

                             <td className='table_item_sm' > {item.service_desc} </td>
                             <td className='table_item_sm' > {item.price} </td>
                             <td className='table_item_sm' > 
                             <img src={item.image} alt="" className="icon_big" />
                              </td>
                              <td>
                                {item.service_type }
                              </td>
                            <td className='d-flex-c' >
                            <button className="edit_btn_admin" onClick={() => updateShownMethod(  item.service_name , item.service_desc ,  item.image , item.price , item.rating , item.id   )  }  >تعديل</button>
                            <button className="delete_btn_admin" onClick={() => deleteShowMethod( item.service_name , item.service_desc ,  item.image , item.price , item.rating , item.id  ) } >حذف</button>
                            </td>

                        </tr>
                        ))}


                    </tbody>

               
                </table>
                )}

              
                </>
            )}
                
             

               
            </div>
        </div>
    </div>

        </div>
    
    )
}

export default SubPackages;